// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Em7mg","label":"styles_label__KaAO9","icon":"styles_icon__xW_YF"};